export const marketplaceAddress = "0xc1eE5f75c70B08E01f3C7E24b9f62a0E4158Cf5F";
export const collectionAddress = "0xEBf512D08196F3039E4c19AD2a09dAaA8e3B3f84";